import React, { Fragment } from 'react'
import { NavLink } from 'react-router-dom'

const IuppHeaderDisconnected = () => {
  return (
    <Fragment>
      <div className='placeholder-header' />
      <header className='iupp-header header-disconnected'>
        <nav className='menu menu-segmentation'>
          <div className='container'>
            <div className='flexible-items-container'>
              <a href='#' className='flex-item mn-item mn-personal' title='Ver as vantages exclusivas para o seu negócios'>para o seu negócio</a>
              <a href='/' className='flex-item mn-item ' title='Ver as vantagens exclusivas para você'>para você</a>
            </div>
          </div>
        </nav>
        <nav className='meu-bairro-head menu menu-navigation '>
          <div className='container'>
            <div className='title-meu-bairro'>
              <a href='/meu-negocio' title='Ir para a página inicial' className='logo-header-community'>
                comunidade <br />
                iupp
              </a>
              {/* <p className='title'>meu negócio</p> */}
            </div>
            <div className='flexible-items-container'>
              <div className='menu-itens'>
                <NavLink to='/meu-negocio/#benefits' data-target='#benefits' className='flex-item mn-item mn-benefits' title='benefícios que vão te ajudar a vender mais.'>benefícios</NavLink>
              </div>
              <div className='menu-itens'>
                <NavLink to='/meu-negocio/#help' data-target='#help' className='flex-item mn-item mn-help' title='está com dúvidas? veja nossas perguntas frequentes.'>ajuda</NavLink>
              </div>
              <a href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN} className='flex-item mn-item mn-login' title='Ir para área de login'>entrar</a>
              <a href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP} className='flex-item mn-item mn-register' title='Fazer cadastro'>cadastre-se</a>
            </div>
          </div>
        </nav>
      </header>
    </Fragment>
  )
}

export default IuppHeaderDisconnected



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/Header/index.js